import React from 'react';
// Modal import removed as it will be handled by App.tsx
// import Modal from './Modal'; 
import { MdPhotoSizeSelectActual } from 'react-icons/md';

export interface HeaderProps {
  filename: string; // This prop is no longer used due to previous changes, consider removing if truly unused.
  onFilenameChange: (name: string) => void; // Also potentially unused.
  isSessionActive: boolean;
  onNewSession: () => void;
  // onSaveText: () => void; // Removed in previous steps
  onLoadText: (sessionId: number) => void; // Will be used by App.tsx for the modal
  onDeleteSession: (sessionId: number) => void; // Will be used by App.tsx for the modal
  onResetEditor: () => void;
  theme: string;
  onToggleTheme: () => void;
  onSettingsClick?: () => void;
  onOpenSessionsClick: () => void; // New prop to signal opening the sessions modal
  onStatisticsClick?: () => void; // New prop for statistics navigation
  onAccountClick?: () => void; // New prop for opening account/auth modal
  user?: any; // User object to show account status
  totalWordsSaved?: number; // Total words saved across all sessions
}

const Header: React.FC<HeaderProps> = ({ 
  // filename, 
  // onFilenameChange, 
  isSessionActive,
  onNewSession,
  onLoadText,      // Prop still received but modal instance is gone
  onDeleteSession, // Prop still received but modal instance is gone
  onResetEditor,
  theme,
  onToggleTheme,
  onSettingsClick,
  onOpenSessionsClick, // Destructure new prop
  onStatisticsClick, // Destructure statistics prop
  onAccountClick, // Destructure account prop
  user, // Destructure user prop
  totalWordsSaved // Total words saved
}) => {
  // const [showMenu, setShowMenu] = useState<boolean>(false); // Removed - no longer needed
  // const [showSessionsModal, setShowSessionsModal] = useState<boolean>(false); // State moved to App.tsx
  
  // const handleFilenameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   onFilenameChange(e.target.value);
  // }; // Commented out as filename input is removed

  // Removed unused handleNewFile function
  
  return (
    <header className="bg-white dark:bg-gray-800 shadow-sm">
      <div className="container mx-auto px-4 py-4">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex items-center">
            <div className="flex flex-col items-center md:items-start">
              <h1 className="text-3xl md:text-2xl font-bold text-primary dark:text-primary">Get Deleto</h1>
              {/* Mobile tagline - only visible on mobile */}
              <div className="block md:hidden text-sm text-gray-600 dark:text-gray-400 text-center mt-1 font-medium">
                <p>Write first, edit later.</p>
                <p className="text-center">Pause for too long and your words vanish.</p>
              </div>
            </div>
          </div>
          
          <div className="flex flex-wrap items-center gap-3 allow-focus">
                      <div className="flex items-center space-x-2">
            {/* Commented out Reopen Session button - user may want to remove this
            <button
              onClick={onOpenSessionsClick} 
              className="btn btn-secondary"
              title="Reopen a saved session"
            >
              <span className="flex items-center">
                <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 19a2 2 0 01-2-2V7a2 2 0 012-2h4l2 2h4a2 2 0 012 2v1M5 19h14a2 2 0 002-2v-5a2 2 0 00-2-2H9a2 2 0 00-2 2v5a2 2 0 01-2 2z" />
                </svg>
                Reopen Session
              </span>
            </button>
            */}
            
            {totalWordsSaved !== undefined && (
              <div className="flex items-center gap-2 mr-2 text-gray-600 dark:text-gray-300 font-medium">
                <span>🏆</span>
                <span>{totalWordsSaved.toLocaleString()} Words Saved</span>
              </div>
            )}
            
            {onStatisticsClick && (
                <button
                  onClick={onStatisticsClick}
                  className="btn btn-secondary"
                  title="View writing statistics"
                >
                  <span className="flex items-center">
                    <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                    </svg>
                    Statistics
                  </span>
                </button>
              )}
              
              <button
                onClick={onToggleTheme}
                className="p-2 rounded-md bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 transition-all duration-300 flex items-center justify-center overflow-hidden relative focus:outline-none focus:ring-2 focus:ring-primary focus:ring-opacity-50"
                title="Change Theme"
                aria-label="Change Theme"
              >
                <MdPhotoSizeSelectActual className="w-5 h-5 text-gray-600 dark:text-gray-300 group-hover:text-primary" />
              </button>
              
              {onSettingsClick && (
                <button
                  onClick={onSettingsClick}
                  className="p-2 rounded-md bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 flex items-center justify-center gap-2"
                  title="Open Settings"
                  aria-label="Open Settings"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                  <span className="text-sm font-medium">Settings</span>
                </button>
              )}
              
              {onAccountClick && (
                <button
                  onClick={onAccountClick}
                  className={`p-2 rounded-md transition-all duration-300 flex items-center justify-center ${
                    user 
                      ? 'bg-green-100 dark:bg-green-900 hover:bg-green-200 dark:hover:bg-green-800 text-green-600 dark:text-green-300' 
                      : 'bg-blue-100 dark:bg-blue-900 hover:bg-blue-200 dark:hover:bg-blue-800 text-blue-600 dark:text-blue-300'
                  } gap-2`}
                  title={user ? 'Account' : 'Sign In'}
                  aria-label={user ? 'Account' : 'Sign In'}
                >
                  {user ? (
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                    </svg>
                  ) : (
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                    </svg>
                  )}
                  <span className="text-sm font-medium">{user ? 'Account' : 'Sign In'}</span>
                </button>
              )}
              
              <a
                href="#/intro"
                className="text-sm font-medium text-primary hover:text-primary-dark transition-colors"
              >
                Intro Page →
              </a>

            </div>
            
            {/* Menu Button (for mobile) - REMOVED */}
            {/* Hamburger menu removed as all buttons are already visible */}

          </div>
        </div>
      </div>
      
      {/* Modal instance removed from here */}
    </header>
  );
};

export default Header; 